import moment from "moment-timezone";
import { RADatePicker, RATimePicker } from "@/components/customs";
import { Row, Col, Grid } from "antd";
import { SvgCalendar, SvgTime } from "@/assets/icons";
import { RADepartureWindow, RAInputTimePickerMobile } from "@/components/atoms";
import { RATypography } from "@/components/customs";
import { useState, useEffect } from "react";
import dayjs from "dayjs";

const { useBreakpoint } = Grid;

export function InputAlertDepartureWindow({ from_datetime, to_datetime, onChange, error }) {
	const screens = useBreakpoint();
	const [isTouchScreen, setIsTouchScreen] = useState(false);

	useEffect(() => {
		if ("ontouchstart" in window || navigator.msMaxTouchPoints > 0 || navigator.maxTouchPoints > 0) {
			setIsTouchScreen(true);
		}
	}, []);
	if (!screens.xs) {
		return (
			<RADepartureWindow
				title="Time Frame (optional)"
				fromDate={from_datetime}
				toDate={to_datetime}
				onChange={(fromDate, toDate) => {
					let customFromDate = fromDate;
					if (!from_datetime) {
						customFromDate = moment(customFromDate).set({ hour: 0, minute: 0 }).toISOString();
					}

					let customToDate = toDate;
					if (!to_datetime) {
						customToDate = moment(customToDate).set({ hour: 23, minute: 59 }).toISOString();
					}

					onChange({
						from_datetime: customFromDate,
						to_datetime: customToDate,
					});
				}}
				error={error?.departure_window}
			/>
		);
	}
	return (
		<Row gutter={[0, 16]}>
			<Col span={24}>
				<Row gutter={[8, 12]}>
					<Col span={12}>
						<RADatePicker
							prefix={<SvgCalendar color="#595959" />}
							placeholder="Start date"
							value={from_datetime || null}
							format="ddd, MMM DD"
							onChange={(val) => {
								let value = val;
								if (!from_datetime) {
									value = moment(val).set({ hour: 0, minute: 0 }).toISOString();
								}
								let values = { from_datetime: value };
								if (to_datetime && moment(value).isAfter(to_datetime)) {
									values = { ...values, to_datetime: "" };
								}
								onChange({ ...values });
							}}
						/>
					</Col>
					<Col span={12}>
						{isTouchScreen ? (
							<div
								style={{
									display: "flex",
									flexDirection: "column",
									justifyContent: "flex-end",
									alignItems: "flex-end",
									width: "100%",
									height: "100%",
								}}
							>
								<RAInputTimePickerMobile
									prefix={<SvgTime color="#595959" />}
									value={from_datetime || null}
									onChange={(val) => {
										let date = from_datetime ? moment(from_datetime) : moment();
										let time = moment(val);
										date = moment(date).set({
											hour: time.get("hour"),
											minute: time.get("minute"),
										});
										let values = {
											from_datetime: date.toISOString(),
										};
										if (to_datetime && moment(date.toISOString()).isAfter(to_datetime)) {
											values = {
												...values,
												to_datetime: "",
											};
										}
										onChange({ ...values });
									}}
								/>
							</div>
						) : (
							<RATimePicker
								prefix={<SvgTime color="#595959" />}
								placeholder="Time"
								value={from_datetime || null}
								dropdownAlign={{ offset: [-44, 4] }}
								onChange={(val) => {
									let date = from_datetime ? moment(from_datetime) : moment();
									let time = moment(val);
									date = moment(date).set({
										hour: time.get("hour"),
										minute: time.get("minute"),
									});
									let values = {
										from_datetime: date.toISOString(),
									};
									if (to_datetime && moment(date.toISOString()).isAfter(to_datetime)) {
										values = { ...values, to_datetime: "" };
									}
									onChange({ ...values });
								}}
							/>
						)}
					</Col>
				</Row>
			</Col>
			<Col span={24}>
				<Row gutter={[8, 12]}>
					<Col span={12}>
						<RADatePicker
							prefix={<SvgCalendar color="#595959" />}
							placeholder="End date"
							value={to_datetime || null}
							disabled={!from_datetime}
							disabledFromDate={from_datetime}
							format="ddd, MMM DD"
							onChange={(val) => {
								let value = val;
								if (!to_datetime) {
									value = moment(val).set({ hour: 23, minute: 59 }).toISOString();
								}
								onChange({
									to_datetime: value,
								});
							}}
							defaultPickerValue={from_datetime ? dayjs(from_datetime, "YYYY-MM") : null}
						/>
					</Col>
					<Col span={12}>
						{isTouchScreen ? (
							<div
								style={{
									display: "flex",
									flexDirection: "column",
									justifyContent: "flex-end",
									alignItems: "flex-end",
									width: "100%",
									height: "100%",
								}}
							>
								<RAInputTimePickerMobile
									prefix={<SvgTime color="#595959" />}
									value={to_datetime || null}
									onChange={(val) => {
										let date = to_datetime ? moment(to_datetime) : moment();
										let time = moment(val);
										date = moment(date).set({
											hour: time.get("hour"),
											minute: time.get("minute"),
										});
										onChange({
											to_datetime: date.toISOString(),
										});
									}}
								/>
							</div>
						) : (
							<RATimePicker
								prefix={<SvgTime color="#595959" />}
								placeholder="Time"
								value={to_datetime || null}
								disabled={!from_datetime}
								dropdownAlign={{ offset: [-44, 4] }}
								onChange={(val) => {
									let date = to_datetime ? moment(to_datetime) : moment();
									let time = moment(val);
									date = moment(date).set({
										hour: time.get("hour"),
										minute: time.get("minute"),
									});
									onChange({
										to_datetime: date.toISOString(),
									});
								}}
							/>
						)}
					</Col>
				</Row>
				{!!error?.departure_window && (
					<RATypography variant="body3" color="#BF1A2F" top="10px">
						{error?.departure_window || ""}
					</RATypography>
				)}
			</Col>
		</Row>
	);
}
